import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Layouts
import { LayoutDashboardComponent } from './layout/layout-dashboard/layout-dashboard.component';
import { LayoutHomeComponent } from './layout/layout-home/layout-home.component';
import { LayoutPropertyComponent } from './layout/layout-property/layout-property.component';

export const routes: Routes = [{
  path: '',
  redirectTo: 'auth',
  pathMatch: 'full',
},
{
  path: 'admin',
  redirectTo: 'properties',
  pathMatch: 'full',
},
{
  path: '',
  component: LayoutDashboardComponent,
  data: {
    title: ''
  },
  children: [
    {
      path: 'dashboard',
      loadChildren: './dashboard/dashboard.module#DashboardModule'
    },
    {
      path: 'property-home',
      loadChildren: './property-identification/property-home/property-home.module#PropertyHomeModule'
    },
    {
      path: 'property-balance',
      loadChildren: './reports/property-balance/property-balance.module#PropertyBalanceModule'
    },
    {
      path: 'common-expense',
      loadChildren: './reports/common-expense/common-expense.module#CommonExpenseModule'
    },
    {
      path: 'advertisement',
      loadChildren: './advertisement/advertisement.module#AdvertisementModule'
    },
    {
      path: 'bill-collection',
      loadChildren: './bill-collection/bill-collection.module#BillCollectionModule'
    },
    {
      path: 'debts',
      loadChildren: './debts/debts.module#DebtsModule'
    },
    {
      path: 'updated-debt',
      loadChildren: './updated-debt/updated-debt.module#UpdatedDebtModule'
    },
    {
      path: 'citation',
      loadChildren: './citation/citation.module#CitationModule'
    },
    // {
    //   path: 'user-info',
    //   loadChildren: './user/user.module#UserModule'
    // },
    {
      path: 'pages/:code',
      loadChildren: './components/pages/pages.module#PagesModule'
    },
    {
      path: 'visitors',
      loadChildren: './security/visitors/visitors.module#VisitorsModule'
    },
    {
      path: 'document-library',
      loadChildren: './document-library/document-library.module#DocumentLibraryModule'
    }
  ]
},
{
  path: '',
  component: LayoutHomeComponent,
  children: [
    {
      path: 'auth',
      loadChildren: './entry-to-system/entry-to-system.module#EntryToSystemModule',
    },
    {
      path: 'khipu',
      loadChildren: './khipu/khipu.module#KhipuModule',
    },
    {
      path: 'billing',
      loadChildren: './billing/billing.module#BillingModule',
    }
  ]
},
{
  path: '',
  component: LayoutPropertyComponent,
  children: [
    {
      path: 'properties',
      loadChildren: './property-identification/properties/properties.module#PropertiesModule'
    }
  ]
}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-router.module.ts